export default __webpack_public_path__ + "static/media/4.a3e47ec4.png";